export const schoolSearchList = [
  "Marywood University",
  "Lindenwood University",
  "Sullivan University",
  "Florida State College at Jacksonville",
  "Xavier University",
  "Tusculum College",
  "Claremont School of Theology",
  "Columbia College (SC)",
  "Chabot-Las Positas Community College District",
  "Keller Graduate School of Management",
  "Monroe College",
  "San Mateo County Community College District",
  "Los Rios Community College District",
  "DigiPen Institute of Technology",
  "University of Pittsburgh Medical Center",
  "Claremont Graduate University",
  "University of Texas Rio Grande Valley",
  "College of Mount Saint Vincent",
  "University of Arkansas System eVersity",
  "ECPI University",
  "University of Mary Washington",
  "Baldwin Wallace University",
  "California State University Channel Islands",
  "Brandman University",
  "United States Coast Guard Academy",
  "Athens State University",
  "The Scripps Research Institute",
  "Eastern Florida State College",
  "Western New England University",
  "King University",
  "Georgia Gwinnett College",
  "Trident University",
  "Alliant International University",
  "Mississippi Valley State University",
  "Roosevelt University",
  "ITT Technical Institute",
  "Illinois Eastern Community Colleges",
  "Park University",
  "Icahn School of Medicine at Mount Sinai",
  "Utah Valley Uniersity",
  "Wisconsin Lutheran College",
  "Riverside Community College District",
  "Wake Forest Baptist Health",
  "University of Massachusetts Boston",
  "Florida Polytechnic University",
  "Wagner College",
  "Wilmington University",
  "International Technological University",
  "Young Harris College",
  "University of Findlay",
  "Philadelphia College of Osteopathic Medicine",
  "Yosemite Community College District",
  "Coastal Alabama Community College",
  "Purdue University Northwest",
  "Columbia Basin College",
  "Seattle Colleges",
  "Lipscomb University",
  "Tiffin University",
  "Troy University",
  "42 US",
  "California Baptist University",
  "Stevenson University",
  "Marine Biological Laboratory",
  "Maryville University",
  "The Art Institutes",
  "University of Mississippi Medical Center",
  "University of Central Oklahoma",
  "Hallmark University",
  "Keiser University",
  "St. Johns River State College",
  "Indian River State College",
  "Barnard College",
  "California Southern University",
  "University of La Verne",
  "Washington & Jefferson College",
  "University of the People",
  "Touro College",
  "New Jersey City University",
  "Lander University",
  "SUNY Maritime College",
  "Lesley University",
  "Laurus College",
  "National Park College",
  "Oklahoma Christian University",
  "San Diego Christian College",
  "SANS Technology Institute",
  "Pasco-Hernando State College",
  "New College of Florida",
  "Grand Canyon University",
  "Cold Spring Harbor Laboratory",
  "Albany State University",
  "Lasell College",
  "Contra Costa Community College District",
  "Mount St. Mary's University",
  "Robert Morris University Illinois",
  "Northwest Florida State College",
  "West Virginia Wesleyan College",
  "Utica College",
  "Career College of Northern Nevada",
  "College of Southern Nevada",
  "University of North Georgia",
  "The Principia",
  "Lynn University",
  "Colorado Community College System",
  "Valencia College",
  "St. Petersburg College",
  "Globe University & Minnesota School of Business",
  "Everest College",
  "Southwest Research Institute",
  "American Public University System",
  "Full Sail University",
  "YTI Career Institute",
  "Defense Language Institute Foreign Language Center",
  "Columbus State University",
  "Morehead State University",
  "Colorado State University - Global Campus",
  "North Dakota University System",
  "University of Houston-Downtown",
  "Stratford University",
  "California Polytechnic State University, Pomona",
  "Baker College",
  "The College of New Jersey",
  "Abilene Christian University",
  "Adelphi University",
  "Agnes Scott College",
  "Aiken Technical College",
  "Air Force Institute of Technology",
  "Alabama A&M University",
  "Alabama State University",
  "Alamo Colleges",
  "Albertson College of Idaho",
  "Albion College",
  "Alfred University",
  "Allegheny College",
  "Allentown College of Saint Francis de Sales",
  "Alma College",
  "Alverno College",
  "Ambassador University",
  "American Coastline University",
  "American International College",
  "American University",
  "Amherst College",
  "Andrews University",
  "Angelo State University",
  "Anne Arundel Community College",
  "Antioch New England",
  "Antioch University",
  "Antioch University - Los Angeles",
  "Antioch University - Seattle",
  "Appalachian State University",
  "Aquinas College",
  "Arcadia College",
  "Arizona State University",
  "Arizona Western College",
  "Arkansas State University",
  "Arkansas Tech University",
  "Armstrong State College",
  "Ashland University",
  "Assumption College",
  "Auburn University",
  "Auburn University at Montgomery",
  "Augsburg College",
  "Augustana College (IL)",
  "Augustana College (SD)",
  "Augusta University",
  "Aurora University",
  "Austin College",
  "Austin Community College",
  "Austin Peay State University",
  "Averett College",
  "Avila College",
  "Azusa Pacific University",
  "Babson College",
  "Baker University",
  "Ball State University",
  "Baptist Bible College",
  "Bard College",
  "Barry University",
  "Bastyr University",
  "Bates College",
  "Baylor College of Medicine",
  "Baylor University",
  "Bellevue University",
  "Belmont University",
  "Beloit College",
  "Bemidji State University",
  "Benedictine College",
  "Bennington College",
  "Bentley College",
  "Berea College",
  "Berklee College of Music",
  "Bethany College",
  "Bethel College (KS)",
  "Bethel University",
  "Biola University",
  "Birmingham-Southern College",
  "Black Hills State University",
  "Bloomsburg University of Pennsylvania",
  "Bluffton College",
  "Bob Jones University",
  "Boise State University",
  "Boston College",
  "Boston Graduate School of Psychoanalysis",
  "Boston University",
  "Bowdoin College",
  "Bowie State University",
  "Bowling Green State University",
  "Bradley University",
  "Brandeis University",
  "Brenau University",
  "Briar Cliff College",
  "Bridgewater College",
  "Brigham Young University",
  "Brigham Young University - Idaho",
  "Brigham Young University Hawaii",
  "Broward College",
  "Brown University",
  "Bryant College",
  "Bryn Mawr College",
  "Bucknell University",
  "Buena Vista University",
  "Butler University",
  "California Coast University",
  "California Institute of Technology",
  "California Lutheran University",
  "California Maritime Academy",
  "California National University",
  "California Polytechnic State University, San Luis Obispo",
  "California State University, Bakersfield",
  "California State University, Chico",
  "California State University, Dominguez Hills",
  "California State University, Fresno",
  "California State University, Fullerton",
  "California State University, Hayward",
  "California State University, Long Beach",
  "California State University, Los Angeles",
  "California State University, Monterey Bay",
  "California State University, Northridge",
  "California State University, Sacramento",
  "California State University, San Bernardino",
  "California State University, San Marcos",
  "California State University, Stanislaus",
  "California State University System",
  "California University of Pennsylvania",
  "Calvin College",
  "Cameron University",
  "Campbellsville College",
  "Campbell University",
  "Canisius College",
  "Capella University",
  "Capitol Technology University",
  "Carleton College",
  "Carlow College",
  "Carnegie Mellon University",
  "Carroll College",
  "Carroll University",
  "Carson-Newman College",
  "Carthage College",
  "Case Western Reserve University",
  "Castleton State University",
  "Catholic University of America",
  "Cedarville College",
  "Centenary College of Louisiana",
  "Central College",
  "Central Connecticut State University",
  "Central Methodist College",
  "Central Michigan University",
  "Central Washington University",
  "Centre College",
  "Chadron State College",
  "Champlain College",
  "Chapman University",
  "Chatham College",
  "Chesapeake College",
  "Cheyney University",
  "Chicago School of Professional Psychology",
  "Christian Brothers University",
  "Christian Theological Seminary",
  "Christopher Newport University",
  "City University",
  "City University of New York",
  "Claremont Graduate School",
  "Claremont McKenna College",
  "Clarion University of Pennsylvania",
  "Clarke College",
  "Clarkson University",
  "Clark University",
  "Clayton State College",
  "Clemson University",
  "Cleveland State University",
  "Clinch Valley College",
  "Coastal Carolina University",
  "Coast Colleges",
  "Coe College",
  "Coker College",
  "Colby College",
  "Colgate University",
  "College of Charleston",
  "College of Eastern Utah",
  "College of New Rochelle",
  "College of Saint Benedict",
  "College of Saint Catherine",
  "College of Saint Rose",
  "College of St. Francis",
  "College of St. Scholastica",
  "College of the Atlantic",
  "College of the Holy Cross",
  "College of William and Mary",
  "College of Wooster",
  "Colorado Christian University",
  "Colorado College",
  "Colorado Mesa University",
  "Colorado School of Mines",
  "Colorado State University",
  "Colorado Technical University",
  "University of Colorado Anschutz Medical Campus",
  "Columbia College Chicago",
  "Columbia Southern University",
  "Columbia Union College",
  "Columbia University",
  "Community College of Baltimore County",
  "Concordia College - Ann Arbor",
  "Concordia College - Moorhead",
  "Concordia College - Seward",
  "Concordia College - St. Paul",
  "Connecticut College",
  "Connecticut State University System",
  "Cooper Union for the Advancement of Science and Art",
  "Coppin State University",
  "Allen College",
  "Cornell College",
  "Cornell University",
  "Corning Community College",
  "Creighton University",
  "Curry College",
  "Daemen College",
  "Dakota State University",
  "Dakota Wesleyan University",
  "Dallas Baptist University",
  "Dallas County Community College",
  "Dana College",
  "Daniel Webster College",
  "Dartmouth College",
  "Davenport University",
  "Davidson College",
  "Davis & Elkins College",
  "Daytona State College",
  "Delaware State University",
  "Delta State University",
  "Denison University",
  "DePaul University",
  "DePauw University",
  "DeVry Institute of Technology",
  "Dickinson College",
  "Dickinson State University",
  "Dillard University",
  "Dominican College",
  "Dordt College",
  "Dowling College",
  "Drake University",
  "Drew University",
  "Drexel University",
  "Drury College",
  "Duquesne University",
  "Earlham College",
  "East Carolina University",
  "East Central University",
  "Eastern Connecticut State University",
  "Eastern Illinois University",
  "Eastern Kentucky University",
  "Eastern Mennonite University",
  "Eastern Michigan University",
  "Eastern New Mexico University",
  "Eastern Oregon State College",
  "Eastern Washington University",
  "East Stroudsburg State University of Pennsylvania",
  "East Tennessee State University",
  "Edgewood College",
  "Edinboro University of Pennsylvania",
  "Elizabeth City State University",
  "Elizabethtown College",
  "Elmhurst College",
  "Elon College",
  "Embry-Riddle Aeronautical University",
  "Emerson College",
  "Emmanuel College",
  "Emory University",
  "Emory & Henry College",
  "Emporia State University",
  "Erie Community College",
  "Lake Erie College of Osteopathic Medicine",
  "East Texas Baptist University",
  "Evergreen State College",
  "Fairleigh Dickinson University",
  "Fairmont State College",
  "Fayetteville State University",
  "Ferris State University",
  "Fielding Institute",
  "Fisk University",
  "Fitchburg State College",
  "Florida Agricultural and Mechanical University",
  "Florida Atlantic University",
  "Florida Gulf Coast University",
  "Florida Institute of Technology",
  "Florida International University",
  "Florida State University",
  "Fontbonne College",
  "Fordham University",
  "Fort Hays State University",
  "Fort Lewis College",
  "Fountainhead College of Technology",
  "Franklin and Marshall College",
  "Franklin Pierce Law Center",
  "Franklin University",
  "Frederick Community College",
  "Fresno Pacific University",
  "Friends University",
  "Frostburg State University",
  "Fuller Theological Seminary",
  "Furman University",
  "Gallaudet University",
  "Gannon University",
  "Geneva College",
  "George Fox College",
  "George Mason University",
  "Georgetown University",
  "George Washington University",
  "Georgia College",
  "Georgia Institute of Technology",
  "Georgian Court University",
  "Georgia Southern University",
  "Georgia Southwestern State University",
  "Georgia State University",
  "Gettysburg College",
  "GMI Engineering and Management Institute",
  "Golden Gate University",
  "Goldey-Beacom College",
  "Gonzaga University",
  "Goshen College",
  "Goucher College",
  "Governors State University",
  "Grace College",
  "Graceland College",
  "Grand Valley State University",
  "Greenleaf University",
  "Grinnell College",
  "Guilford College",
  "Gustavus Adolphus College",
  "Hagerstown Community College",
  "Hamilton College",
  "Hamline University",
  "Hampden-Sydney College",
  "Hampshire College",
  "Hampton University",
  "Hanover College",
  "Harding University",
  "Harford Community College",
  "Hartwick College",
  "Harvard University",
  "Harvey Mudd College",
  "Haskell Indian Nations University",
  "Hastings College",
  "Haverford College in Pennsylvania",
  "Hawaii Pacific University",
  "Heidelberg College",
  "Hendrix College",
  "Hesston College",
  "High Point University",
  "Hillsdale College",
  "Hiram College",
  "Hobart and William Smith Colleges",
  "Hofstra University",
  "Hollins College",
  "Hood College",
  "Hope College",
  "Howard Community College",
  "Howard University",
  "Humboldt State University",
  "Huntingdon College",
  "Huntington University",
  "ICI University",
  "Idaho State University",
  "Illinois Benedictine College",
  "Illinois Institute of Technology",
  "Illinois State University",
  "Indiana Institute of Technology",
  "Indiana State University",
  "Indiana University",
  "Indiana University at Bloomington",
  "Indiana University at South Bend",
  "Indiana University of Pennsylvania",
  "Indiana University/Purdue University at Columbus",
  "Indiana University/Purdue University at Fort Wayne",
  "Indiana University/Purdue University at Indianapolis",
  "Indiana University Southeast",
  "Indiana Wesleyan University, Marion",
  "Institute for World Politics",
  "Iona College",
  "Iowa State University",
  "Irvine Valley College",
  "Ithaca College",
  "Jackson State University",
  "Jacksonville State University",
  "Jacksonville University",
  "James Madison University",
  "John Brown University",
  "John F. Kennedy University",
  "Johns Hopkins University",
  "Johns Hopkins University Applied Physics Laboratory",
  "Johnson & Wales University",
  "Johnson Bible College",
  "Johnson C. Smith University",
  "Jones College",
  "Judson College",
  "Juniata College",
  "Kalamazoo College",
  "Kansas State University",
  "Kansas Wesleyan University",
  "Kaplan University",
  "Kean College",
  "Keene State College",
  "Kennesaw State University",
  "Kent State University",
  "Kentucky Community & Technical College System",
  "Kenyon College",
  "Kettering University",
  "King's College",
  "Knox College",
  "Kutztown University of Pennsylvania",
  "Lafayette College",
  "LaGrange College",
  "Lake Forest College",
  "Lake Superior College",
  "Lake Superior State University",
  "Lamar University",
  "Langston University",
  "LaSalle University",
  "La Sierra University",
  "Lawrence Technological University",
  "Lawrence University",
  "Lebanon Valley College",
  "Lehigh University",
  "Le Moyne College",
  "Lenoir Community College",
  "Lenoir-Rhyne College",
  "LeTourneau University",
  "Lewis & Clark College",
  "Lewis-Clark State College",
  "Lewis University",
  "Liberty University",
  "Lincoln University",
  "Linfield College",
  "Lock Haven University",
  "Loma Linda University",
  "Long Island University",
  "Longwood University",
  "Loras College",
  "Los Angeles Community College District",
  "Louisiana College",
  "Louisiana State University",
  "Louisiana State University at Alexandria",
  "Louisiana Tech University",
  "Loyola College",
  "Loyola Marymount University",
  "Loyola University Chicago",
  "Luther College",
  "Luther Seminary",
  "Lycoming College",
  "Lynchburg College",
  "Lyndon State College",
  "Lyon College",
  "Macalester College",
  "Maharishi University of Management",
  "Malone College",
  "Manhattan College",
  "Mansfield University of Pennsylvania",
  "Marietta College",
  "Marist College",
  "Marlboro College",
  "Marquette University",
  "Marshall University",
  "Mary Baldwin College",
  "Marymount Manhattan College",
  "Marymount University",
  "Mary Washington College",
  "Massachusetts Institute of Technology",
  "McDaniel College",
  "McMurry University",
  "McNeese State University",
  "Medical College of Georgia",
  "Medical College of Wisconsin",
  "Mercer County Community College",
  "Mercer University",
  "Mercy College",
  "Mercyhurst University",
  "Meredith College",
  "Messiah College",
  "Metropolitan Community College (MO)",
  "Metropolitan Community College (NE)",
  "Metropolitan State College of Denver",
  "Denver College of Nursing",
  "Metropolitan State University",
  "Miami University of Ohio",
  "Michigan State University",
  "Michigan Technological University",
  "Mid-America Nazarene College",
  "Middlebury College",
  "Middle Georgia State College",
  "Middle Tennessee State University",
  "Midwestern State University",
  "Millersville University of Pennsylvania",
  "Milligan College",
  "Millikin University",
  "Millsaps College",
  "Milwaukee School of Engineering",
  "Minneapolis College of Art and Design",
  "Minnesota State University, Mankato",
  "Minnesota State University Moorhead",
  "Minot State University",
  "Mississippi College",
  "Mississippi State University",
  "Mississippi University for Women",
  "Missouri Southern State College",
  "Missouri University of Science and Technology",
  "Missouri Western State College",
  "Molloy College",
  "Monmouth College",
  "Monmouth University",
  "Montana State University - Billings",
  "Montana State University - Bozeman",
  "Montana State University - Northern",
  "Montana Tech",
  "Montclair State University",
  "Montgomery College",
  "Montreat College",
  "Moravian College",
  "Morgan State University",
  "Mott Community College",
  "Mount Holyoke College",
  "Mount Saint Joseph College",
  "Mount Saint Mary College",
  "Mount Senario College",
  "Mount Union College",
  "Murray State University",
  "Muskingum College",
  "Nashville State Community College",
  "National Defense University",
  "National-Louis University",
  "National Radio Astronomy Observatory",
  "National University",
  "Naval Postgraduate School",
  "Nazareth College",
  "Nevada System of Higher Education",
  "Newberry College",
  "New College of California",
  "New England Institute of Technology",
  "New Hampshire College",
  "New Jersey Institute of Technology",
  "New Mexico Highlands University",
  "New Mexico Institute of Mining & Technology",
  "New Mexico State University",
  "New York Institute of Technology",
  "New York University",
  "Niagara University",
  "Nicholls State University",
  "Norfolk State University",
  "North American University",
  "Northampton Community College",
  "North Carolina A&T State University",
  "North Carolina Central University",
  "North Carolina State University",
  "North Carolina Wesleyan College",
  "North Central Bible College",
  "North Dakota State University",
  "Northeastern Louisiana University",
  "Northeastern State University",
  "Northeastern University",
  "Northern Arizona University",
  "Northern Illinois University",
  "Northern Kentucky University",
  "Northern Michigan University",
  "Northern State University",
  "Northland College",
  "North Park College and Theological Seminary",
  "Northwestern College of Iowa",
  "Northwestern State University",
  "Northwestern University",
  "Northwest Missouri State University",
  "Northwest Nazarene College",
  "Norwich University",
  "Nova Southeastern University",
  "Oakland University",
  "Oakwood University",
  "Oberlin College",
  "Occidental College",
  "Ohio Dominican College",
  "Ohio Northern University",
  "Ohio State University, Columbus",
  "Ohio University",
  "Ohio Wesleyan University",
  "Oklahoma Baptist University",
  "Oklahoma City University",
  "Oklahoma State University",
  "Old Dominion University",
  "Olivet Nazarene University",
  "Oral Roberts University",
  "Oregon Graduate Institute of Science and Technology",
  "Oregon Health Sciences University",
  "Oregon Institute of Technology",
  "Oregon State University",
  "Otterbein College",
  "Our Lady of the Lake University",
  "Pace University",
  "Pacific Lutheran University",
  "Pacific Union College",
  "Pacific University",
  "Pacific Western University",
  "Palm Beach Atlantic College",
  "Palm Beach State College",
  "Peace College",
  "Pembroke State University",
  "Pennsylvania College of Technology",
  "Pennsylvania State University",
  "Pennsylvania State University - Schuylkill Campus",
  "Pensacola Christian College",
  "Pensacola State College",
  "Pepperdine University",
  "Peru State College",
  "Purdue University Fort Wayne",
  "Philadelphia University",
  "Phillips University",
  "Pittsburg State University",
  "Pitzer College",
  "Platt College",
  "Plymouth State College",
  "Polytechnic University of New York",
  "Polytechnic University of Puerto Rico",
  "Pomona College",
  "Portland Community College",
  "Portland State University",
  "Prairie View A&M University",
  "Pratt Institute",
  "Presbyterian College",
  "Prescott College",
  "Princeton University",
  "Providence College",
  "Purdue University",
  "Purdue University Calumet",
  "Purdue University North Central",
  "Quincy University",
  "Quinnipiac College",
  "Radford University",
  "Ramapo College",
  "Randolph-Macon College",
  "Randolph-Macon Woman's College",
  "Reed College",
  "Regent University",
  "Regis University",
  "Rensselaer Polytechnic Institute",
  "Rhode Island College",
  "Rhodes College",
  "Rice University",
  "Richard Stockton College of New Jersey",
  "Rider University",
  "Ripon College",
  "Rivier College",
  "Roanoke College",
  "Robert Morris University",
  "Rochester Institute of Technology",
  "Rockefeller University",
  "Rockford College",
  "Rockhurst College",
  "Rocky Mountain College",
  "Roger Williams University",
  "Rollins College",
  "Rosary College",
  "Rose-Hulman Institute of Technology",
  "Rowan College",
  "Rutgers University",
  "Sacred Heart University",
  "Sage Colleges",
  "Saginaw Valley State University",
  "Saint Anselm College",
  "Saint Cloud State University",
  "Saint Edward's University",
  "Saint Francis College",
  "Saint John's University (NY)",
  "Saint Joseph's College (IN)",
  "Saint Joseph's University",
  "Saint Leo University",
  "Saint Louis University",
  "Saint Mary College",
  "Saint Mary's College (IN)",
  "Saint Mary's College of California",
  "Saint Mary's University of Minnesota",
  "Saint Michael's College",
  "Saint Olaf College",
  "Saint Vincent College",
  "Saint Xavier University",
  "Salisbury University",
  "Salish Kootenai College",
  "Samford University",
  "Sam Houston State University",
  "San Diego State University",
  "San Francisco State University",
  "San Jose State University",
  "Santa Clara University",
  "Sarah Lawrence College",
  "School of the Art Institute of Chicago",
  "Seattle Central College",
  "Seattle Pacific University",
  "Seattle University",
  "Seton Hall University",
  "Sewanee, University of the South",
  "Shawnee State University",
  "Shenandoah University",
  "Shippensburg University of Pennsylvania",
  "Shorter College",
  "Simmons College",
  "Simon's Rock College",
  "Simpson College",
  "Sinclair Community College",
  "Skidmore College",
  "Slippery Rock University of Pennsylvania",
  "Smith College",
  "Sonoma State University",
  "South Dakota School of Mines and Technology",
  "South Dakota State University",
  "Southeastern Louisiana University",
  "Southeast Missouri State University",
  "Southern College",
  "Southern College of Technology",
  "Southern Connecticut State University",
  "Southern Illinois University-Carbondale",
  "Southern Illinois University-Edwardsville",
  "Southern Methodist University",
  "Southern Nazarene University",
  "Southern New Hampshire University",
  "Southern Oregon State College",
  "Southern University and A&M College",
  "Southern Utah University",
  "South Texas College of Law",
  "Southwest Baptist University",
  "Southwestern Adventist College",
  "Southwestern Assemblies of God University",
  "Southwestern College (KS)",
  "Southwestern University",
  "Southwest Missouri State University",
  "Southwest Texas State University",
  "Spelman College",
  "Spring Arbor College",
  "Spring Hill College",
  "St. Ambrose University",
  "St. Andrews Presbyterian College",
  "Stanford University",
  "State University of New York at Albany",
  "State University of New York at Binghamton",
  "State University of New York at Buffalo",
  "State University of New York at Farmingdale",
  "State University of New York at Fredonia",
  "State University of New York at Oswego",
  "State University of New York at Plattsburgh",
  "State University of New York at Stony Brook",
  "Academic medical center at State University of New York at Stony Brook",
  "State University of New York College at Brockport",
  "State University of New York College at Buffalo",
  "State University of New York College at Cortland",
  "State University of New York College at Geneseo",
  "State University of New York College at New Paltz",
  "State University of New York College at Potsdam",
  "State University of New York College of Agriculture and Technology at Cobleskill",
  "State University of New York College of Environmental Science and Forestry",
  "State University of New York College of Technology at Alfred",
  "State University of New York Polytechnic Institute",
  "State University of New York System",
  "St. Bonaventure University",
  "Stephen F. Austin State University",
  "Stephens College",
  "Stetson University",
  "Stevens Institute of Technology",
  "St. John's College - Annapolis",
  "St. John's College - Santa Fe",
  "St. Joseph College (CT)",
  "St. Joseph's College (ME)",
  "St. Lawrence University",
  "St. Louis College of Pharmacy",
  "St. Martin's College",
  "St. Mary's College of Maryland",
  "Strayer College",
  "St. Thomas University (FL)",
  "Suffolk University",
  "Sul Ross State University",
  "Summit University of Louisiana",
  "Susquehanna University",
  "Swarthmore College",
  "Sweet Briar College",
  "Syracuse University",
  "Tabor College",
  "Tarleton State University",
  "Taylor University",
  "Temple University",
  "Tennessee State University",
  "Tennessee Technological University",
  "Terrant County College",
  "Texas A&M International University",
  "Texas A&M University - College Station",
  "Texas A&M University - Commerce",
  "Texas A&M University - Corpus Christi",
  "Texas A&M University - Kingsville",
  "Texas Christian University",
  "Texas Southern University",
  "Texas State University",
  "Texas Tech University",
  "Texas Tech University-Health Sciences Center",
  "Texas Woman's University",
  "The Citadel",
  "The Jewish Theological Seminary",
  "Thomas College",
  "Thomas Edison State University",
  "Thomas Jefferson University",
  "Thomas More College",
  "Thunderbird School of Global Management",
  "Towson University",
  "Transylvania University",
  "Trenton State College",
  "Trine University",
  "Trinity College (CT)",
  "Trinity College (DC)",
  "Trinity University",
  "Troy State University",
  "Truman State University",
  "Tucson University",
  "Tufts University",
  "Tulane University",
  "Tuskegee University",
  "Uniformed Services University of the Health Sciences",
  "Union College",
  "Union Institute",
  "Union University",
  "United States Air Force Academy",
  "United States International University",
  "United States Merchant Marine Academy",
  "United States Military Academy",
  "United States Naval Academy",
  "University of Advancing Technology",
  "University of Akron",
  "University of Alabama at Birmingham",
  "University of Alabama at Huntsville",
  "University of Alaska",
  "University of Alaska - Anchorage",
  "University of Alaska - Fairbanks",
  "University of Alaska - Southeast",
  "University of Arizona",
  "University of Arkansas - Fayetteville",
  "University of Arkansas - Fort Smith",
  "University of Arkansas for Medical Sciences",
  "University of Arkansas - Little Rock",
  "University of Arkansas - Monticello",
  "University of Baltimore",
  "University of Bridgeport",
  "University of California, Berkeley",
  "University of California, Davis",
  "University of California, Irvine",
  "University of California, Los Angeles",
  "University of California, Merced",
  "University of California, Office of the President",
  "University of California, Riverside",
  "University of California, San Diego",
  "University of California, San Francisco",
  "University of California, Santa Barbara",
  "University of California, Santa Cruz",
  "University of Central Arkansas",
  "University of Central Florida",
  "University of Central Missouri",
  "UC Hastings College of the Law",
  "University of Charleston",
  "University of Chicago",
  "University of Cincinnati",
  "University of Colorado at Boulder",
  "University of Colorado at Colorado Springs",
  "University of Colorado at Denver",
  "University of Colorado Health Sciences Center",
  "University of Connecticut",
  "University of Dallas",
  "University of Dayton",
  "University of Delaware",
  "University of Denver",
  "University of Detroit Mercy",
  "University of Dubuque",
  "University of Evansville",
  "University of Florida",
  "University of Georgia",
  "University of Great Falls",
  "University of Hartford",
  "University of Hawaii at Hilo",
  "University of Hawaii at Manoa",
  "University of Hawaii System",
  "University of Houston",
  "University of Idaho",
  "University of Illinois at Chicago",
  "University of Illinois at Springfield",
  "University of Illinois at Urbana-Champaign",
  "University of Indianapolis",
  "University of Iowa",
  "University of Jamestown",
  "University of Kansas",
  "University of Kansas School of Medicine",
  "University of Kentucky",
  "University of Louisiana at Lafeyette",
  "University of Louisiana at Monroe",
  "University of Louisville",
  "University of Maine",
  "University of Maine at Farmington",
  "University of Maine at Fort Kent",
  "University of Maine at Machias",
  "University of Maine at Presque Island",
  "University of Maine System",
  "University of Maryland, Baltimore",
  "Mayo Clinic",
  "University of Maryland, Baltimore County",
  "University of Maryland, College Park",
  "University of Maryland Eastern Shore",
  "University of Maryland - University College",
  "University of Massachusetts at Amherst",
  "University of Massachusetts at Dartmouth",
  "University of Massachusetts at Lowell",
  "University of Memphis",
  "University of Miami",
  "University of Michigan - Ann Arbor",
  "University of Michigan - Dearborn",
  "University of Minnesota",
  "University of Minnesota - Crookston",
  "University of Minnesota - Duluth",
  "University of Minnesota - Morris",
  "University of Mississippi",
  "University of Missouri",
  "University of Missouri - Kansas City",
  "University of Missouri - Rolla",
  "University of Missouri - Saint Louis",
  "University of Montana",
  "University of Nebraska, Kearney",
  "University of Nebraska, Lincoln",
  "University of Nebraska, Omaha",
  "University of Nevada, Las Vegas",
  "University of Nevada, Reno",
  "University of New England",
  "University of New Hampshire, Durham",
  "University of New Haven",
  "University of New Mexico",
  "University of New Orleans",
  "University of North Carolina at Asheville",
  "University of North Carolina at Chapel Hill",
  "University of North Carolina at Charlotte",
  "University of North Carolina at Greensboro",
  "University of North Carolina at Wilmington",
  "University of North Dakota",
  "University of Northern Colorado",
  "University of Northern Iowa",
  "University of North Florida",
  "University of North Texas",
  "University of North Texas Health Science Center",
  "University of Notre Dame",
  "University of Oklahoma",
  "University of Oregon",
  "University of Pennsylvania",
  "University of Phoenix",
  "University of Pittsburgh",
  "University of Pittsburgh at Johnstown",
  "University of Pittsburgh at Bradford",
  "University of Portland",
  "University of Puerto Rico",
  "University of Puget Sound",
  "University of Redlands",
  "University of Rhode Island",
  "University of Richmond",
  "University of Rochester",
  "University of Saint Thomas (MN)",
  "University of Saint Thomas (TX)",
  "University of San Diego",
  "University of San Francisco",
  "University of Science & Arts of Oklahoma",
  "University of Scranton",
  "University of Sioux Falls",
  "University of South Alabama",
  "University of South Carolina",
  "Anderson University",
  "University of South Carolina - Aiken",
  "University of South Dakota",
  "University of Southern California",
  "University of Southern Indiana",
  "University of Southern Maine",
  "University of Southern Mississippi",
  "University of South Florida",
  "University of Southwestern Louisiana",
  "University of Tampa",
  "University of Tennessee at Chattanooga",
  "University of Tennessee, Knoxville",
  "University of Tennessee, Martin",
  "University of Texas at Arlington",
  "University of Texas at Austin",
  "University of Texas at Brownsville",
  "University of Texas at Dallas",
  "University of Texas at El Paso",
  "University of Texas at San Antonio",
  "University of Texas at Tyler",
  "University of Texas Medical Branch",
  "University of Texas - Pan American",
  "University of Texas Southwestern Medical Center",
  "University of Texas Permian Basin",
  "University of the District of Columbia",
  "University of the Incarnate Word",
  "University of the Ozarks",
  "University of the Pacific",
  "University of Toledo",
  "University of Tulsa",
  "University of Utah",
  "University of Vermont",
  "University of Virginia, Charlottesville",
  "University of Washington",
  "University of West Alabama",
  "University of West Florida",
  "University of Wisconsin - Eau Claire",
  "University of Wisconsin - Green Bay",
  "University of Wisconsin - LaCrosse",
  "University of Wisconsin - Madison",
  "University of Wisconsin - Milwaukee",
  "University of Wisconsin - Oshkosh",
  "University of Wisconsin - Parkside",
  "University of Wisconsin - Platteville",
  "University of Wisconsin - River Falls",
  "University of Wisconsin - Stevens Point",
  "University of Wisconsin - Stout",
  "University of Wisconsin - Superior",
  "University of Wisconsin System",
  "University of Wisconsin - Whitewater",
  "University of Wyoming",
  "Upper Iowa University",
  "Ursinus College",
  "Utah State University",
  "Utah Valley State College",
  "Valdosta State University",
  "Valley City State University",
  "Valparaiso University",
  "Vance-Granville Community College",
  "Vanderbilt University",
  "Vassar College",
  "Vermont Technical College",
  "Villa Julie College",
  "Villanova University",
  "Virginia Commonwealth University",
  "Virginia Community College System",
  "Virginia Intermont College",
  "Virginia Military Institute",
  "Virginia Polytechnic Institute and State University",
  "Virginia State University",
  "Virginia Wesleyan College",
  "Wabash College",
  "Wake Forest University",
  "Walden University",
  "Walla Walla University",
  "Walsh College",
  "Warren Wilson College",
  "Wartburg College",
  "Washburn University",
  "Washington & Lee University",
  "Washington Bible College/Capital Bible Seminary",
  "Washington College",
  "Washington State University",
  "Washington State University at Vancouver",
  "Washington University, Saint Louis",
  "Waubonsee Community College",
  "Waynesburg College",
  "Wayne State University",
  "Weber State University",
  "Webster University",
  "Wellesley College",
  "Wells College",
  "Wentworth Institute of Technology",
  "Wesleyan University",
  "Wesley College",
  "West Chester University of Pennsylvania",
  "West Coast University",
  "Western Carolina University",
  "Western Connecticut State University",
  "Western Governors University",
  "Western Illinois University",
  "Western Kentucky University",
  "Western Michigan University",
  "Western Montana College",
  "Western New England College",
  "Western New Mexico University",
  "Western State Colorado University",
  "Western Washington University",
  "Westfield State College",
  "West Georgia College",
  "West Liberty State College",
  "Westminster College",
  "Westminster College",
  "Westminster College of Salt Lake City",
  "Westminster Theological Seminary",
  "Westmont College",
  "West Texas A&M University",
  "West Virginia University",
  "West Virginia University at Parkersburg",
  "Wheaton College",
  "Wheaton College, Norton MA",
  "Wheeling Jesuit College",
  "Whitman College",
  "Whittier College",
  "Whitworth College",
  "Wichita State University",
  "Widener University",
  "Wilberforce University",
  "Wilkes University",
  "Willamette University",
  "William Howard Taft University",
  "William Jewell College",
  "William Mitchell College of Law",
  "William Paterson University",
  "William Penn College",
  "Williams College",
  "William Woods University",
  "Wilmington College",
  "Winona State University",
  "Winthrop University",
  "Wittenberg University",
  "Wofford College",
  "Woodbury University",
  "Worcester Polytechnic Institute",
  "Wright State University",
  "Xavier University of Louisiana",
  "Yale University",
  "Yeshiva University",
  "York College of Pennsylvania",
  "Youngstown State University",
  "Houston Baptist University",
  "Brookings Institution",
  "Alabama Southern Community College",
  "Bevill State Community College",
  "Bishop State Community College",
  "Central Alabama Community College",
  "Chattahoochee Valley Community College",
  "Duke University",
  "Enterprise State Community College",
  "Gadsden State Community College",
  "George C Wallace State Community College-\u200bDothan",
  "George C Wallace State Community College-\u200bHanceville",
  "George C Wallace State Community College-\u200bSelma",
  "H Councill Trenholm State Technical College",
  "James H Faulkner State Community College",
  "Jefferson Davis Community College",
  "Jefferson State Community College",
  "J F Drake State Community and Technical College",
  "Calhoun Community College",
  "Lurleen B Wallace Community College",
  "Marion Military Institute",
  "Northeast Alabama Community College",
  "Northwest-\u200bShoals Community College",
  "Shelton State Community College",
  "Snead State Community College",
  "Southern Union State Community College",
  "Ilisagvik College",
  "Prince William Sound College",
  "Central Arizona College",
  "Chandler-\u200bGilbert Community College",
  "Cochise College",
  "Coconino Community College",
  "Eastern Arizona College",
  "GateWay Community College",
  "Glendale Community College",
  "Mesa Community College",
  "Mohave Community College",
  "Northland Pioneer College",
  "Paradise Valley Community College",
  "Phoenix College",
  "Pima Community College",
  "Rio Salado College",
  "Scottsdale Community College",
  "South Mountain Community College",
  "Tohono O'Odham Community College",
  "Yavapai College",
  "Arkansas Northeastern College",
  "Arkansas State University-\u200bBeebe",
  "Arkansas State University-\u200bMountain Home",
  "Arkansas State University-\u200bNewport",
  "Black River Technical College",
  "College of the Ouachitas",
  "Cossatot Community College of the University of Arkansas",
  "East Arkansas Community College",
  "Mid-\u200bSouth Community College",
  "National Park Community College",
  "North Arkansas College",
  "NorthWest Arkansas Community College",
  "Ozarka College",
  "Phillips Community College of the University of Arkansas",
  "Pulaski Technical College",
  "Rich Mountain Community College",
  "South Arkansas Community College",
  "Southeast Arkansas College",
  "Southern Arkansas University Tech",
  "University of Arkansas Community College-\u200bBatesville",
  "University of Arkansas Community College-\u200bHope",
  "University of Arkansas Community College-\u200bMorrilton",
  "Allan Hancock College",
  "American River College",
  "Antelope Valley College",
  "Bakersfield College",
  "Barstow Community College",
  "Berkeley City College",
  "Butte College",
  "Cabrillo College",
  "Canada College",
  "Carrington College California-\u200bSacramento",
  "Cerritos College",
  "Cerro Coso Community College",
  "Chabot College",
  "Chaffey College",
  "Citrus College",
  "City College of San Francisco",
  "Coastline Community College",
  "College of Alameda",
  "College of Marin",
  "College of San Mateo",
  "College of the Canyons",
  "College of the Desert",
  "College of the Redwoods",
  "College of the Sequoias",
  "College of the Siskiyous",
  "Columbia College (MO)",
  "Columbia College (CA)",
  "Contra Costa College",
  "Copper Mountain Community College",
  "Cosumnes River College",
  "Crafton Hills College",
  "Cuesta College",
  "Cuyamaca College",
  "Cypress College",
  "De Anza College",
  "Diablo Valley College",
  "East Los Angeles College",
  "El Camino College-\u200bCompton Center",
  "El Camino Community College District",
  "Evergreen Valley College",
  "Feather River Community College District",
  "Folsom Lake College",
  "Foothill College",
  "Fresno City College",
  "Fullerton College",
  "Gavilan College",
  "Glendale Community College",
  "Golden West College",
  "Grossmont College",
  "Hartnell College",
  "Imperial Valley College",
  "Lake Tahoe Community College",
  "Laney College",
  "Las Positas College",
  "Lassen Community College",
  "Long Beach City College",
  "Los Angeles City College",
  "Los Angeles County College of Nursing and Allied Health",
  "Los Angeles Harbor College",
  "Los Angeles Mission College",
  "Los Angeles Pierce College",
  "Los Angeles Southwest College",
  "Los Angeles Trade Technical College",
  "Los Angeles Valley College",
  "Los Medanos College",
  "Mendocino College",
  "Merced College",
  "Merritt College",
  "MiraCosta College",
  "Mission College",
  "Modesto Junior College",
  "Monterey Peninsula College",
  "Moorpark College",
  "Moreno Valley College",
  "MTI College",
  "Mt. San Antonio College",
  "Mt. San Jacinto Community College District",
  "Napa Valley College",
  "Ohlone College",
  "Orange Coast College",
  "Oxnard College",
  "Palomar College",
  "Palo Verde College",
  "Pasadena City College",
  "Porterville College",
  "Reedley College",
  "Rio Hondo College",
  "Riverside City College",
  "Sacramento City College",
  "Saddleback College",
  "San Bernardino Valley College",
  "San Diego City College",
  "San Diego Mesa College",
  "San Diego Miramar College",
  "San Joaquin Delta College",
  "San Joaquin Valley College-\u200bVisalia",
  "San Jose City College",
  "Santa Ana College",
  "Santa Barbara City College",
  "Santa Monica College",
  "Santa Rosa Junior College",
  "Santiago Canyon College",
  "Shasta College",
  "Sierra College",
  "Skyline College",
  "Solano Community College",
  "Southwestern College (CA)",
  "Taft College",
  "Ventura College",
  "Victor Valley College",
  "West Hills College-\u200bCoalinga",
  "West Los Angeles College",
  "West Valley College",
  "Woodland Community College",
  "Yuba College",
  "Aims Community College",
  "Arapahoe Community College",
  "Colorado Northwestern Community College",
  "Community College of Aurora",
  "Community College of Denver",
  "Front Range Community College",
  "Lamar Community College",
  "Morgan Community College",
  "Northeastern Junior College",
  "Otero Junior College",
  "Pikes Peak Community College",
  "Pueblo Community College",
  "Red Rocks Community College",
  "Trinidad State Junior College",
  "Asnuntuck Community College",
  "Capital Community College",
  "Gateway Community College",
  "Housatonic Community College",
  "Manchester Community College",
  "Middlesex Community College",
  "Naugatuck Valley Community College",
  "Northwestern Connecticut Community College",
  "Norwalk Community College",
  "Quinebaug Valley Community College",
  "Three Rivers Community College",
  "Tunxis Community College",
  "Delaware College of Art and Design",
  "Delaware Technical Community College",
  "Florida Keys Community College",
  "Hillsborough Community College",
  "North Florida Community College",
  "Pasco-\u200bHernando Community College",
  "Tallahassee Community College",
  "Albany Technical College",
  "Andrew College",
  "Athens Technical College",
  "Atlanta Technical College",
  "Augusta Technical College",
  "Bainbridge State College",
  "Central Georgia Technical College",
  "Chattahoochee Technical College",
  "Columbus Technical College",
  "Darton State College",
  "Georgia Highlands College",
  "Georgia Military College",
  "Georgia Northwestern Technical College",
  "Georgia Perimeter College",
  "Georgia Piedmont Technical College",
  "Gwinnett Technical College",
  "Lanier Technical College",
  "Moultrie Technical College",
  "North Georgia Technical College",
  "Ogeechee Technical College",
  "Coastal Pines Technical College",
  "Savannah Technical College",
  "Southeastern Technical College",
  "Southern Crescent Technical College",
  "South Georgia Technical College",
  "Southwest Georgia Technical College",
  "West Georgia Technical College",
  "Wiregrass Georgia Technical College",
  "Hawaii Community College",
  "Honolulu Community College",
  "Kapiolani Community College",
  "Kauai Community College",
  "Leeward Community College",
  "Windward Community College",
  "College of Southern Idaho",
  "College of Western Idaho",
  "Eastern Idaho Technical College",
  "North Idaho College",
  "Black Hawk College",
  "Carl Sandburg College",
  "City Colleges of Chicago",
  "College of DuPage",
  "College of DuPage",
  "College of Lake County",
  "Danville Area Community College",
  "Elgin Community College",
  "Fox College",
  "Harper College",
  "Heartland Community College",
  "Highland Community College",
  "Illinois Central College",
  "Illinois Valley Community College",
  "John A Logan College",
  "John Wood Community College",
  "Joliet Junior College",
  "Kankakee Community College",
  "Kaskaskia College",
  "Kishwaukee College",
  "Lake Land College",
  "Le Cordon Bleu College of Culinary Arts-\u200bChicago",
  "Lewis and Clark Community College",
  "Lincoln Land Community College",
  "MacCormac College",
  "McHenry County College",
  "Moraine Valley Community College",
  "Morton College",
  "Northwestern College-\u200bChicago Campus",
  "Oakton Community College",
  "Parkland College",
  "Prairie State College",
  "Rend Lake College",
  "Richland Community College",
  "Rock Valley College",
  "Sauk Valley Community College",
  "Shawnee Community College",
  "Southeastern Illinois College",
  "South Suburban College",
  "Southwestern Illinois College",
  "Spoon River College",
  "Triton College",
  "Ancilla College",
  "Ivy Tech Community College",
  "Des Moines Area Community College",
  "Eastern Iowa Community College District",
  "Hawkeye Community College",
  "Indian Hills Community College",
  "Iowa Central Community College",
  "Iowa Lakes Community College",
  "Iowa Western Community College",
  "Kirkwood Community College",
  "Marshalltown Community College",
  "Northeast Iowa Community College",
  "North Iowa Area Community College",
  "Northwest Iowa Community College",
  "Southeastern Community College",
  "Southwestern Community College",
  "Western Iowa Tech Community College",
  "Allen County Community College",
  "Barton County Community College",
  "Butler Community College",
  "Cloud County Community College",
  "Coffeyville Community College",
  "Colby Community College",
  "Cowley County Community College",
  "Dodge City Community College",
  "Flint Hills Technical College",
  "Fort Scott Community College",
  "Garden City Community College",
  "Highland Community College",
  "Hutchinson Community College",
  "Independence Community College",
  "Johnson County Community College",
  "Kansas City Kansas Community College",
  "Labette Community College",
  "Manhattan Area Technical College",
  "Neosho County Community College",
  "North Central Kansas Technical College",
  "Northwest Kansas Technical College",
  "Pratt Community College",
  "Seward County Community College and Area Technical School",
  "Wichita Area Technical College",
  "Ashland Community and Technical College",
  "Big Sandy Community and Technical College",
  "Bluegrass Community and Technical College",
  "Elizabethtown Community and Technical College",
  "Galen College of Nursing-\u200bLouisville",
  "Gateway Community and Technical College",
  "Hazard Community and Technical College",
  "Henderson Community College",
  "Hopkinsville Community College",
  "Jefferson Community and Technical College",
  "Madisonville Community College",
  "Maysville Community and Technical College",
  "Owensboro Community and Technical College",
  "Somerset Community College",
  "Southcentral Kentucky Community and Technical College",
  "Southeast Kentucky Community and Technical College",
  "West Kentucky Community and Technical College",
  "Baton Rouge Community College",
  "Bossier Parish Community College",
  "Delgado Community College",
  "L E Fletcher Technical Community College",
  "Louisiana Delta Community College",
  "Louisiana State University-\u200bEunice",
  "Nunez Community College",
  "River Parishes Community College",
  "Southern University at Shreveport",
  "South Louisiana Community College",
  "SOWELA Technical Community College",
  "Central Maine Community College",
  "Central Maine Medical Center College of Nursing and Health Professions",
  "Eastern Maine Community College",
  "Kennebec Valley Community College",
  "Northern Maine Community College",
  "Southern Maine Community College",
  "Washington County Community College",
  "York County Community College",
  "Allegany College of Maryland",
  "Baltimore City Community College",
  "Carroll Community College",
  "Cecil College",
  "College of Southern Maryland",
  "Garrett College",
  "Prince George's Community College",
  "Wor-\u200bWic Community College",
  "Berkshire Community College",
  "Bristol Community College",
  "Bunker Hill Community College",
  "Cape Cod Community College",
  "Greenfield Community College",
  "Holyoke Community College",
  "Massachusetts Bay Community College",
  "Massasoit Community College",
  "Middlesex Community College",
  "Mount Wachusett Community College",
  "Northern Essex Community College",
  "North Shore Community College",
  "Quincy College",
  "Quinsigamond Community College",
  "Roxbury Community College",
  "Springfield Technical Community College",
  "Urban College of Boston",
  "Alpena Community College",
  "Bay de Noc Community College",
  "Bay Mills Community College",
  "Delta College",
  "Glen Oaks Community College",
  "Gogebic Community College",
  "Grand Rapids Community College",
  "Henry Ford College",
  "Jackson College",
  "Kalamazoo Valley Community College",
  "Kellogg Community College",
  "Keweenaw Bay Ojibwa Community College",
  "Kirtland Community College",
  "Lake Michigan College",
  "Lansing Community College",
  "Macomb Community College",
  "Mid Michigan Community College",
  "Monroe County Community College",
  "Montcalm Community College",
  "Muskegon Community College",
  "North Central Michigan College",
  "Oakland Community College",
  "Saginaw Chippewa Tribal College",
  "Schoolcraft College",
  "Southwestern Michigan College",
  "St. Clair County Community College",
  "Washtenaw Community College",
  "Wayne County Community College District",
  "West Shore Community College",
  "Alexandria Technical & Community College",
  "Anoka-\u200bRamsey Community College",
  "Anoka Technical College",
  "Central Lakes College-\u200bBrainerd",
  "Century College",
  "Dakota County Technical College",
  "Fond du Lac Tribal and Community College",
  "Hennepin Technical College",
  "Hibbing Community College",
  "Inver Hills Community College",
  "Itasca Community College",
  "Leech Lake Tribal College",
  "Mesabi Range Community and Technical College",
  "Minneapolis Community and Technical College",
  "Minnesota State College-\u200bSoutheast Technical",
  "Minnesota State Community and Technical College",
  "Minnesota West Community and Technical College",
  "Normandale Community College",
  "North Hennepin Community College",
  "Northland Community and Technical College",
  "Northwest Technical College",
  "Pine Technical College",
  "Rainy River Community College",
  "Ridgewater College",
  "Riverland Community College",
  "Rochester Community and Technical College",
  "Saint Paul College",
  "South Central College",
  "St Cloud Technical and Community College",
  "Vermilion Community College",
  "White Earth Tribal and Community College",
  "Coahoma Community College",
  "Copiah-\u200bLincoln Community College",
  "East Central Community College",
  "East Mississippi Community College",
  "Hinds Community College",
  "Holmes Community College",
  "Itawamba Community College",
  "Jones County Junior College",
  "Meridian Community College",
  "Mississippi Delta Community College",
  "Mississippi Gulf Coast Community College",
  "Northeast Mississippi Community College",
  "Northwest Mississippi Community College",
  "Pearl River Community College",
  "Southwest Mississippi Community College",
  "Crowder College",
  "East Central College",
  "Jefferson College",
  "Linn State Technical College",
  "Mineral Area College",
  "Missouri State University",
  "Missouri State University-\u200bWest Plains",
  "Moberly Area Community College",
  "North Central Missouri College",
  "Ozarks Technical Community College",
  "Southeast Missouri Hospital College of Nursing and Health Sciences",
  "State Fair Community College",
  "St Charles Community College",
  "Three Rivers Community College",
  "Wentworth Military Academy & Junior College",
  "Aaniiih Nakoda College",
  "Blackfeet Community College",
  "Chief Dull Knife College",
  "Dawson Community College",
  "Flathead Valley Community College",
  "Fort Peck Community College",
  "Great Falls College Montana State University",
  "Helena College University of Montana",
  "Little Big Horn College",
  "Miles Community College",
  "Stone Child College",
  "Central Community College",
  "Little Priest Tribal College",
  "Mid-\u200bPlains Community College",
  "Nebraska College of Technical Agriculture",
  "Nebraska Indian Community College",
  "Northeast Community College",
  "Southeast Community College Area",
  "Western Nebraska Community College",
  "Truckee Meadows Community College",
  "Great Bay Community College",
  "Lakes Region Community College",
  "Manchester Community College",
  "Nashua Community College",
  "NHTI-\u200bConcord's Community College",
  "River Valley Community College",
  "White Mountains Community College",
  "Assumption College for Sisters",
  "Atlantic Cape Community College",
  "Bergen Community College",
  "Brookdale Community College",
  "Burlington County College",
  "Camden County College",
  "County College of Morris",
  "Cumberland County College",
  "Essex County College",
  "Gloucester County College",
  "Hudson County Community College",
  "Middlesex County College",
  "Ocean County College",
  "Passaic County Community College",
  "Raritan Valley Community College",
  "Salem Community College",
  "Sussex County Community College",
  "Union County College",
  "Warren County Community College",
  "Central New Mexico Community College",
  "Clovis Community College",
  "Eastern New Mexico University-\u200bRoswell Campus",
  "Luna Community College",
  "Mesalands Community College",
  "New Mexico Junior College",
  "New Mexico Military Institute",
  "New Mexico State University-\u200bAlamogordo",
  "New Mexico State University-\u200bCarlsbad",
  "New Mexico State University-\u200bDona Ana",
  "San Juan College",
  "Santa Fe Community College",
  "Southwestern Indian Polytechnic Institute",
  "Adirondack Community College",
  "American Academy of Dramatic Arts-\u200bNew York",
  "ASA College",
  "Cayuga County Community College",
  "Clinton Community College",
  "Columbia-\u200bGreene Community College",
  "CUNY Borough of Manhattan Community College",
  "CUNY Bronx Community College",
  "CUNY Hostos Community College",
  "CUNY Kingsborough Community College",
  "CUNY LaGuardia Community College",
  "CUNY Queensborough Community College",
  "CUNY Baruch College",
  "CUNY Queens College",
  "CUNY City Tech",
  "CUNY City College of NY",
  "CUNY Brooklyn College",
  "CUNY Medgar Evers College",
  "CUNY College of Staten Island",
  "CUNY Macauly Honors College",
  "Dutchess Community College",
  "Finger Lakes Community College",
  "Fulton-\u200bMontgomery Community College",
  "Genesee Community College",
  "Herkimer County Community College",
  "Hudson Valley Community College",
  "Jamestown Community College",
  "Jefferson Community College",
  "Mohawk Valley Community College",
  "Monroe Community College",
  "Nassau Community College",
  "Niagara County Community College",
  "North Country Community College",
  "Onondaga Community College",
  "Orange County Community College",
  "Rockland Community College",
  "Saint Elizabeth College of Nursing",
  "Schenectady County Community College",
  "Suffolk County Community College",
  "Sullivan County Community College",
  "SUNY Broome Community College",
  "SUNY Westchester Community College",
  "Technical Career Institutes",
  "Tompkins Cortland Community College",
  "Ulster County Community College",
  "Alamance Community College",
  "Asheville-\u200bBuncombe Technical Community College",
  "Beaufort County Community College",
  "Bladen Community College",
  "Blue Ridge Community College",
  "Brunswick Community College",
  "Caldwell Community College and Technical Institute",
  "Cape Fear Community College",
  "Carolinas College of Health Sciences",
  "Carteret Community College",
  "Catawba Valley Community College",
  "Central Carolina Community College",
  "Central Piedmont Community College",
  "Cleveland Community College",
  "Coastal Carolina Community College",
  "College of the Albemarle",
  "Craven Community College",
  "Davidson County Community College",
  "Durham Technical Community College",
  "Edgecombe Community College",
  "Fayetteville Technical Community College",
  "Forsyth Technical Community College",
  "Gaston College",
  "Guilford Technical Community College",
  "Halifax Community College",
  "Haywood Community College",
  "Isothermal Community College",
  "James Sprunt Community College",
  "Johnston Community College",
  "Louisburg College",
  "Martin Community College",
  "Mayland Community College",
  "McDowell Technical Community College",
  "Mitchell Community College",
  "Montgomery Community College",
  "Nash Community College",
  "Pamlico Community College",
  "Piedmont Community College",
  "Pitt Community College",
  "Randolph Community College",
  "Richmond Community College",
  "Roanoke-\u200bChowan Community College",
  "Robeson Community College",
  "Rockingham Community College",
  "Rowan-\u200bCabarrus Community College",
  "Sampson Community College",
  "Sandhills Community College",
  "Southeastern Community College",
  "South Piedmont Community College",
  "Southwestern Community College",
  "Stanly Community College",
  "Surry Community College",
  "Tri-\u200bCounty Community College",
  "Wake Technical Community College",
  "Wayne Community College",
  "Western Piedmont Community College",
  "Wilkes Community College",
  "Wilson Community College",
  "Cankdeska Cikana Community College",
  "Dakota College at Bottineau",
  "Lake Region State College",
  "North Dakota State College of Science",
  "Williston State College",
  "Belmont College",
  "Central Ohio Technical College",
  "Chatfield College",
  "Cincinnati State Technical and Community College",
  "Clark State Community College",
  "Columbus State Community College",
  "Cuyahoga Community College District",
  "Davis College",
  "Eastern Gateway Community College",
  "Edison State Community College",
  "Hocking College",
  "James A Rhodes State College",
  "Lakeland Community College",
  "Lorain County Community College",
  "Marion Technical College",
  "North Central State College",
  "Northwest State Community College",
  "Ohio State University Agricultural Technical Institute",
  "Owens Community College",
  "Southern State Community College",
  "Stark State College",
  "Terra State Community College",
  "University of Akron Wayne College",
  "Washington State Community College",
  "Zane State College",
  "Carl Albert State College",
  "Connors State College",
  "Eastern Oklahoma State College",
  "Murray State College",
  "Northeastern Oklahoma A&M College",
  "Northern Oklahoma College",
  "Oklahoma City Community College",
  "Redlands Community College",
  "Rose State College",
  "Seminole State College",
  "Tulsa Community College",
  "Western Oklahoma State College",
  "Blue Mountain Community College",
  "Central Oregon Community College",
  "Chemeketa Community College",
  "Clackamas Community College",
  "Clatsop Community College",
  "Columbia Gorge Community College",
  "Klamath Community College",
  "Lane Community College",
  "Linn-\u200bBenton Community College",
  "Mt. Hood Community College",
  "Rogue Community College",
  "Southwestern Oregon Community College",
  "Tillamook Bay Community College",
  "Treasure Valley Community College",
  "Umpqua Community College",
  "Bucks County Community College",
  "Butler County Community College",
  "Community College of Allegheny County",
  "Community College of Beaver County",
  "Community College of Philadelphia",
  "Delaware County Community College",
  "Harcum College",
  "Harrisburg Area Community College-\u200bHarrisburg",
  "Lackawanna College",
  "Lehigh Carbon Community College",
  "Luzerne County Community College",
  "Manor College",
  "Montgomery County Community College",
  "Pennsylvania Highlands Community College",
  "Pennsylvania Institute of Technology",
  "Pittsburgh Technical Institute",
  "Reading Area Community College",
  "Thaddeus Stevens College of Technology",
  "University of Pittsburgh-\u200bTitusville",
  "Valley Forge Military Academy and College",
  "Westmoreland County Community College",
  "Community College of Rhode Island",
  "Central Carolina Technical College",
  "Denmark Technical College",
  "Florence-\u200bDarlington Technical College",
  "Greenville Technical College",
  "Horry-\u200bGeorgetown Technical College",
  "Midlands Technical College",
  "Northeastern Technical College",
  "Orangeburg Calhoun Technical College",
  "Piedmont Technical College",
  "Spartanburg Community College",
  "Spartanburg Methodist College",
  "Technical College of the Lowcountry",
  "Tri-\u200bCounty Technical College",
  "Trident Technical College",
  "Williamsburg Technical College",
  "York Technical College",
  "Kilian Community College",
  "Lake Area Technical Institute",
  "Mitchell Technical Institute",
  "Sisseton Wahpeton College",
  "Southeast Technical Institute",
  "Western Dakota Technical Institute",
  "Chattanooga State Community College",
  "Cleveland State Community College",
  "Columbia State Community College",
  "Dyersburg State Community College",
  "Jackson State Community College",
  "John A Gupton College",
  "Motlow State Community College",
  "Northeast State Community College",
  "Pellissippi State Community College",
  "Roane State Community College",
  "Southwest Tennessee Community College",
  "Volunteer State Community College",
  "Walters State Community College",
  "Alvin Community College",
  "Amarillo College",
  "Angelina College",
  "Blinn College",
  "Brookhaven College",
  "Cedar Valley College",
  "Central Texas College",
  "Schreiner University",
  "Cisco College",
  "Clarendon College",
  "Coastal Bend College",
  "College of the Mainland",
  "Collin County Community College District",
  "Del Mar College",
  "Eastfield College",
  "El Centro College",
  "El Paso Community College",
  "Frank Phillips College",
  "Galveston College",
  "Grayson College",
  "Hill College",
  "Houston Community College",
  "Howard College",
  "Jacksonville College-\u200bMain Campus",
  "Kilgore College",
  "Lamar Institute of Technology",
  "Lamar State College-\u200bOrange",
  "Lamar State College-\u200bPort Arthur",
  "Laredo Community College",
  "Lee College",
  "Lone Star College System",
  "McLennan Community College",
  "Navarro College",
  "North Central Texas College",
  "Northeast Texas Community College",
  "North Lake College",
  "Odessa College",
  "Alamo Colleges District",
  "Panola College",
  "Paris Junior College",
  "Ranger College",
  "Richland College",
  "South Plains College",
  "Southwest Texas Junior College",
  "Temple College",
  "Texarkana College",
  "Texas State Technical College-\u200bHarlingen",
  "Texas State Technical College-\u200bMarshall",
  "Texas State Technical College-\u200bWaco",
  "Texas State Technical College-\u200bWest Texas",
  "Trinity Valley Community College",
  "Tyler Junior College",
  "Vernon College",
  "Victoria College",
  "Weatherford College",
  "Western Texas College",
  "Wharton County Junior College",
  "Latter-day Saints Business College",
  "Salt Lake Community College",
  "Community College of Vermont",
  "Blue Ridge Community College",
  "Central Virginia Community College",
  "Dabney S Lancaster Community College",
  "Danville Community College",
  "Eastern Shore Community College",
  "Germanna Community College",
  "John Tyler Community College",
  "J Sargeant Reynolds Community College",
  "Lord Fairfax Community College",
  "Mountain Empire Community College",
  "New River Community College",
  "Northern Virginia Community College",
  "Patrick Henry Community College",
  "Paul D Camp Community College",
  "Piedmont Virginia Community College",
  "Rappahannock Community College",
  "Richard Bland College of the College of William and Mary",
  "Southside Virginia Community College",
  "Southwest Virginia Community College",
  "Thomas Nelson Community College",
  "Tidewater Community College",
  "Virginia Highlands Community College",
  "Virginia Western Community College",
  "Wytheville Community College",
  "Bates Technical College",
  "Bellingham Technical College",
  "Big Bend Community College",
  "Cascadia Community College",
  "Clark College",
  "Clover Park Technical College",
  "Edmonds Community College",
  "Everett Community College",
  "Grays Harbor College",
  "Green River Community College",
  "Highline Community College",
  "Lower Columbia College",
  "Pierce College at Puyallup",
  "Renton Technical College",
  "Shoreline Community College",
  "Skagit Valley College",
  "South Puget Sound Community College",
  "Spokane Community College",
  "Spokane Falls Community College",
  "Tacoma Community College",
  "Walla Walla Community College",
  "Wenatchee Valley College",
  "Whatcom Community College",
  "Yakima Valley Community College",
  "Blue Ridge Community and Technical College",
  "Bridgemont Community and Technical College",
  "Eastern West Virginia Community and Technical College",
  "Huntington Junior College",
  "Kanawha Valley Community and Technical College",
  "Mountwest Community and Technical College",
  "New River Community and Technical College",
  "Pierpont Community and Technical College",
  "Southern West Virginia Community and Technical College",
  "West Virginia Northern Community College",
  "Blackhawk Technical College",
  "Chippewa Valley Technical College",
  "Fox Valley Technical College",
  "Gateway Technical College",
  "Lac Courte Oreilles Ojibwa Community College",
  "Lakeshore Technical College",
  "Madison Area Technical College",
  "Mid-\u200bState Technical College",
  "Milwaukee Area Technical College",
  "Moraine Park Technical College",
  "Nicolet Area Technical College",
  "Northcentral Technical College",
  "Northeast Wisconsin Technical College",
  "Southwest Wisconsin Technical College",
  "University of Wisconsin Colleges",
  "Waukesha County Technical College",
  "Western Technical College",
  "Wisconsin Indianhead Technical College",
  "Casper College",
  "Central Wyoming College",
  "Eastern Wyoming College",
  "Laramie County Community College",
  "Northwest College",
  "Sheridan College",
  "Western Wyoming Community College",
  "Trinity Bible College & Graduate School",
  "University of Michigan-Flint",
  "Kenai Peninsula College",
  "Mat-Su College",
  "Kodiak College",
  "Alaska Pacific University",
  "Wayland Baptist University",
  "Polk State College",
  "Brescia University",
  "Rogers State University",
  "Neumann University",
  "Savannah College of Art and Design",
  "Ashford University",
  "McPherson College",
  "Community College System of New Hampshire",
  "Defiance College",
  "Medical University of South Carolina",
  "Gulf Coast State College",
  "Academy of Art University",
  "Lenoir-Rhyne University",
  "Point Park University",
  "Northwood University",
  "Clark Atlanta University",
  "Morehouse",
  "University of St. Augustine for Health Sciences",
  "California Institute of the Arts",
  "Des Moines University",
  "Utah Tech University",
  "Midwestern University",
  "Illinois Wesleyan University",
  "Maryville College",
  "Endicott College",
  "The University of Alabama",
  "Great Basin College",
  "Einsteinmed",
  "Miami Dade College",
  "Florida SouthWestern State College",
  "Bishop McNamara High School",
  "Chaminade University of Honolulu",
  "Dalton State College",
  "Ojai Unified School District",
  "Bismark State College",
  "Quadrat Academy",
  "University of North Alabama",
  "Bellevue College",
  "CUNY Lehman College",
  "CUNY John Jay College of Criminal Justice",
  "CUNY Hunter College",
  "CUNY York College",
  "Pennsylvania State University - Harrisburg",
  "Alcorn State University",
  "Allen University",
  "American Baptist College",
  "Arkansas at Pine Bluff, University of",
  "Arkansas Baptist College",
  "Barber-Scotia College",
  "Benedict College",
  "Bennett College",
  "Bethune-Cookman University",
  "Bluefield State College",
  "Carver College",
  "Central State University",
  "Claflin University",
  "Clinton College",
  "Edward Waters University",
  "Florida Memorial University",
  "Fort Valley State University",
  "Gasden State Community College",
  "Grambling State University",
  "Harris-Stowe State University",
  "Hood Theological",
  "Huston-Tillotson University",
  "Interdenominational Theological Center",
  "Jarvis Christian College",
  "Johnson C Smith Theological Seminary *",
  "Kentucky State University",
  "Knoxville College",
  "Lane College",
  "Lawson State Community College",
  "LeMoyne-Owen College",
  "Livingstone College",
  "Meharry Medical College",
  "Miles College",
  "Miles School of Law",
  "Morehouse School of Medicine",
  "Morris Brown College",
  "Morris College",
  "Paine College",
  "Paul Quinn College",
  "Philander Smith College",
  "Rust College",
  "Savannah State University",
  "Selma University",
  "Shaw University",
  "Simmons College of Kentucky",
  "South Carolina State University",
  "Southern University at New Orleans",
  "Southwestern Christian College",
  "St. Augustine's University",
  "Stillman College",
  "Talladega College",
  "Texas College",
  "Tougaloo College",
  "Virginia Union University",
  "Virginia University of Lynchburg",
  "Voorhees University",
  "West Virginia State University",
  "Wiley College",
  "Winston-Salem State University",
  "Unity College",
  "Catawba College",
];
